import {
  Popover,
  PopoverBackdrop,
  PopoverBody,
  PopoverContent,
  Pressable,
  PopoverArrow,
} from "@gluestack-ui/themed";
import React from "react";
import { TooltipProps } from "@components/atoms/Tooltip/types";

const Tooltip = ({
  isOpen,
  setIsOpen,
  trigger,
  children,
  tooltipBackgroundColor,
  showOnPress,
  onTriggerPress,
  onClose,
  popoverProps,
  popoverContentProps,
  popoverBodyProps,
  disableTriggerShowEffect,
  showArrowIcon = true,
  useRNModal = false,
  supportedOrientations,
  alignment = "center",
  placement = "bottom",
}: TooltipProps) => {
  return (
    <Popover
      useRNModal={useRNModal}
      onClose={() => {
        onClose?.();
        setIsOpen(false);
      }}
      onOpen={() => setIsOpen((open) => !open)}
      placement={placement}
      shouldFlip={true}
      isOpen={isOpen}
      size="md"
      trigger={(triggerProps) => {
        return (
          <Pressable
            {...triggerProps}
            onPress={() => {
              if (showOnPress && !disableTriggerShowEffect) {
                onTriggerPress?.();
                setIsOpen(true);
              }
            }}
          >
            {({ hovered }: { hovered: boolean }) => {
              if (hovered && !showOnPress && !disableTriggerShowEffect) {
                setIsOpen(true);
              }

              return trigger;
            }}
          </Pressable>
        );
      }}
      {...popoverProps}
      {...(supportedOrientations && { supportedOrientations })}
    >
      <PopoverBackdrop backgroundColor={"transparent"} />
      <PopoverContent
        backgroundColor={tooltipBackgroundColor}
        width={popoverProps?.size ? undefined : 175}
        alignItems={alignment}
        {...popoverContentProps}
      >
        {showArrowIcon && (
          <PopoverArrow backgroundColor={tooltipBackgroundColor} />
        )}
        <PopoverBody {...popoverBodyProps}>{children}</PopoverBody>
      </PopoverContent>
    </Popover>
  );
};

export default Tooltip;
